export const MESSAGE_PER_PAGE = 20;
